'use client';

import { useConsents } from '../../providers/consents';

const CookieTypeDescription = () => {
  const { selectedCookieType } = useConsents();

  return selectedCookieType.description;
};

export default CookieTypeDescription;
